'use strict';

export default function jsonConfiguration(id, fallback)
{
    try {
        const configuration = document.getElementById(id);
        return configuration ? JSON.parse(configuration.textContent.replace(/\\x([0-9a-f]{2})/g, (_, pair) => String.fromCharCode(parseInt(pair, 16)))) : fallback;
    } catch (e) {
        console.log(e);
        return fallback;
    }
}
